<template>
  <AttributeRenderer :product-attributes="calculatedGenericProductAttributeSections" />
</template>

<script setup lang="ts">
import type { ProductAttribute } from '~/shared/types'

interface AccordionProductAttributes {
  productAttribute: ProductAttribute
}

const props = defineProps<AccordionProductAttributes>()

const calculatedGenericProductAttributeSections = computed(() => {
  return props.productAttribute.productAttributeCategories.flatMap((attributeCategory) => {
    return {
      categoryHeading: attributeCategory.categoryHeading,
      categorySections: attributeCategory.productAttributeCategorySections.map((attributeCategorySection) => {
        return {
          sectionHeading: attributeCategorySection.sectionHeading,
          sectionTooltip: attributeCategorySection.sectionTooltip,
          attributes: attributeCategorySection.categoryAttributes,
        }
      })
    }
  })
})
</script>
